import { atom } from 'jotai';

export interface RainfallTracker {
  toastId: string | number;
  batchId: string;
  projectId: string;
  sourceLayerId: string;
  sourceLayerName: string;
  /** Snapshot of layer IDs that were already derived from `sourceLayerId`
   * at the moment the user clicked Run. The "new layer" produced by this
   * run is any layer with `metadata.derivedFrom === sourceLayerId` whose
   * id is NOT in this snapshot. Same disambiguation strategy as deviation
   * / ground-classify — we deliberately do NOT compare against a
   * client-captured timestamp because client/server clock skew bit that
   * approach in earlier hooks (toast either resolved instantly against a
   * stale layer or spun forever).
   *
   * A rainfall run produces THREE derived layers (the GROUP parent, the
   * TILE child for the flow-accumulation heatmap, and the VECTOR child
   * for the flow-features GeoJSON). All three are inserted in one
   * postprocess transaction with `derivedFrom` set on each, so the hook
   * resolves as soon as any one of them appears — that's enough to
   * signal "the work is done" to the user.
   */
  existingDerivedLayerIds: string[];
}

export const rainfallTrackingAtom = atom<RainfallTracker[]>([]);
